import { Icon } from "antd";
import "./style.scss";
import * as React from "react";

interface WarningBarProps {
  icon: string;
  children?: string | JSX.Element;
}

const icons: any = {
  exclamation: <Icon type="exclamation-circle" />
};

export const WarningBar = (props: WarningBarProps) => (
  <div className="warning-bar">
    {props.icon && icons[props.icon]}
    <div style={{ colour: "#979B9F", display: "inline-block" }}>
      {props.children}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./client/modules/common/components/WarningBar/index.tsx